import React from 'react';
import Card from './Card';
import AnimatedNumber from './AnimatedNumber';

const ACCENT = {
  brand: 'text-brand-400',
  success: 'text-emerald-400',
  warning: 'text-amber-400',
  danger: 'text-rose-400',
  info: 'text-sky-400',
};

const ACCENT_BG = {
  brand: 'bg-brand-500/10 text-brand-400',
  success: 'bg-emerald-500/10 text-emerald-400',
  warning: 'bg-amber-500/10 text-amber-400',
  danger: 'bg-rose-500/10 text-rose-400',
  info: 'bg-sky-500/10 text-sky-400',
};

/**
 * KPI tile: small uppercase label, animated number value, optional sub-text and icon.
 */
function KpiCard({
  label,
  value,
  decimals = 0,
  suffix = '',
  prefix = '',
  sub,
  trend, // { value: number, direction: 'up' | 'down' | 'flat' }
  accent = 'brand',
  icon,
  raw = false, // skip animation; render `value` as-is
}) {
  const accentClass = ACCENT[accent] || ACCENT.brand;
  const iconWrapClass = ACCENT_BG[accent] || ACCENT_BG.brand;

  return (
    <Card hover className="p-5">
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
          {label}
        </p>
        {icon && (
          <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${iconWrapClass}`}>
            {icon}
          </div>
        )}
      </div>
      <p className={`text-3xl font-bold tracking-tight ${accentClass}`}>
        {raw ? (
          <>{prefix}{value}{suffix}</>
        ) : (
          <AnimatedNumber
            value={typeof value === 'number' ? value : 0}
            decimals={decimals}
            suffix={suffix}
            prefix={prefix}
          />
        )}
      </p>
      {(sub || trend) && (
        <div className="flex items-center gap-2 mt-2">
          {trend && (
            <span
              className={`inline-flex items-center text-xs font-semibold ${
                trend.direction === 'up'
                  ? 'text-emerald-400'
                  : trend.direction === 'down'
                  ? 'text-rose-400'
                  : 'text-slate-400'
              }`}
            >
              {trend.direction === 'up' ? '↑' : trend.direction === 'down' ? '↓' : '→'}
              {' '}
              {Math.abs(trend.value).toFixed(1)}%
            </span>
          )}
          {sub && (
            <span className="text-xs text-slate-500 dark:text-slate-400">{sub}</span>
          )}
        </div>
      )}
    </Card>
  );
}

export default KpiCard;
